module.exports = __webpack_public_path__ + "static/media/ic_tv.a783ec42.svg";